<dx-popup
    #reverseFromWorkflowEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="25%"
    height="20%"
    [title]="title"
    [showCloseButton]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <fieldset class="field-set">
                        <legend>Actions</legend>
                        <div class="fieldset-container">
                            <dx-radio-group
                                valueExpr="action"
                                displayExpr="text"
                                [items]="reverseActions"
                                [(value)]="selectedReverseAction"
                            ></dx-radio-group>
                        </div>
                    </fieldset>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="top-padding">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Ok"
                                    [icon]="iconCheck"
                                    (onClick)="onOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
